/** Chart palette aligned with classic actual / estimated / projected legend. */
export const digitalTwinChartColors = {
  actual: '#0f172a',
  estimated: '#2563eb',
  projected: '#64748b',
  target: '#94a3b8',
  axis: '#64748b',
  grid: 'rgba(15, 23, 42, 0.06)',
  tooltipBg: 'rgba(255, 255, 255, 0.98)',
  tooltipBorder: 'rgba(15, 23, 42, 0.1)',
  injection: '#ea580c',
  milestoneBirth: '#64748b',
  milestoneWeaned: '#ea580c',
  milestoneSlaughter: '#4338ca',
  milestoneTenWeeks: '#2563eb'
} as const;
